import React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { TimePickerField } from "../fields/TimePickerField";

interface Props
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  label?: string;
  helperText?: string;
  labelIcon?: React.ReactNode;
  name: string;
}

export const TimePickerInput = ({ name, onChange, ...rest }: Props) => {
  const { control, register, getFieldState, formState } = useFormContext();

  const { ref, onChange: hookOnChange, ...hookFormProps } = register(name);

  const customOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    hookOnChange(e);
    if (onChange) {
      onChange(e);
    }
  };

  const value =
    useWatch({
      name,
      control,
    }) || "";

  return (
    <TimePickerField
      errorMessage={getFieldState(name, formState).error?.message}
      value={value}
      innerRef={ref}
      onChange={customOnChange}
      {...rest}
      {...hookFormProps}
    />
  );
};
